/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconTransfer = createReactComponent("transfer", "IconTransfer", [
  ["path", { d: "M20 10h-16l5.5 -6", key: "svg-0" }],
  ["path", { d: "M4 14h16l-5.5 6", key: "svg-1" }]
]);

export { IconTransfer as default };
//# sourceMappingURL=IconTransfer.js.map
